/**
 * this will navigate to native camera view activity in android
 *
 * function play:
 *
 * 0. friendlyName
 * 1. ip:string
 * 2. port:number
 * 3. cameraId:string
 * 4. userName:string
 * 5. password:string
 */

import { NativeModules } from "react-native";

class IPCameraHelper {
  constructor() {
    this.play = (
      friendlyName = "",
      ip = "",
      port = "8800",
      cameraId = "",
      userName = "",
      password = "",
      hasDoorLock = false,
      serverIp = "",
      accessToken = ""
    ) => {
      NativeModules.IPCameraView.play(
        friendlyName,
        ip,
        port,
        cameraId,
        userName,
        password,
        hasDoorLock,
        serverIp,
        accessToken
      );
    };
  }
}

export default IPCameraHelper;
